import { z } from "zod";
import { AdvisorId, ClientId, DateSchema } from "../Types";
export const RelationshipNoteId = z
    .string()
    .startsWith("NTE_") // NTE => Note
    .regex(/^NTE_[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/, {
    message: "RelationshipNoteId must be in the format NTE_XXXX-XXXX-XXXX",
})
    .brand("RelationshipNoteId");
// Request types for POST
export const CreateRelationshipNoteRequest = z.object({
    note: z.string().min(1, "Note content cannot be empty"),
});
// Response types
export const RelationshipNoteNotList = z.object({
    noteId: RelationshipNoteId,
    advisorId: AdvisorId,
    clientId: ClientId,
    note: z.string(),
    title: z.string(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
    updatedBy: AdvisorId,
});
export const CreateRelationshipNoteResponse = z.object({
    data: RelationshipNoteNotList,
});
// Delete response types - matches backend DELETE endpoint response
export const DeletedNote = z.object({
    noteId: RelationshipNoteId,
    deletedAt: z.string().datetime(),
});
export const DeleteRelationshipNoteResponse = z.object({
    data: z.object({
        deletedNote: DeletedNote,
    }),
});
// Update request types for PATCH
export const UpdateRelationshipNoteRequest = z.object({
    note: z.string().min(1, "Note content cannot be empty"),
});
// Update response types for PATCH
export const UpdateRelationshipNoteResponse = z.object({
    data: RelationshipNoteNotList,
});
// Get single relationship note details types
export const RelationshipNoteDetails = z.object({
    noteId: RelationshipNoteId,
    clientId: ClientId,
    clientName: z.string(),
    note: z.string(),
    createdAt: z.string().datetime(),
    createdById: AdvisorId,
    createdByName: z.string(),
    updatedAt: z.string().datetime(),
    updatedById: AdvisorId,
    updatedByName: z.string(),
    wordCount: z.number(),
    characterCount: z.number(),
});
export const GetRelationshipNoteDetailsResponse = z.object({
    data: RelationshipNoteDetails,
});
//# sourceMappingURL=types.js.map